import { render } from "./scalelangdetaileditor.vue?vue&type=template&id=311e9610"
import script from "./scalelangdetaileditor.vue?vue&type=script&lang=js"
export * from "./scalelangdetaileditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__